import styled from "styled-components";
import images from "../images";
import { DESKTOP_MEDIA_QUERY } from "../constants";

export const Wrapper = styled.div`
  padding: 21px 23px;
`;

export const Title = styled.div`
  margin: 0 23px;
  font-size: 16px;
  font-weight: 600;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 48px;
  }
`;

export const Subtitle = styled.div`
  margin: 6px 23px;
  font-size: 14px;
  font-weight: 600;
  color: #0000ff;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 36px;
  }
`;

export const TopicsWrapper = styled.div``;

export const TopicLabel = styled.div`
  margin: 0 auto;
  max-width: 900px;
  margin-bottom: 5px;
  padding-left: 25px;
  font-size: 14px;
  font-weight: 600;
  color: #ff0000;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 24px;
    padding-left: 0px;
  }
`;

export const TopicWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TopicBlock = styled.div`
  width: 100%;
  max-width: 900px;
  min-height: 66px;
  padding: 6px;
  border: 2px solid #ff0000;
  background-color: #e6e6e6;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;

  ${DESKTOP_MEDIA_QUERY} {
    font-size: 24px;
    padding: 14px 22px;
    min-height: 81px;
  }
`;

export const ArrowRight = styled.div`
  width: 13px;
  height: 23px;

  flex-shrink: 0;

  margin: 0 0 0 12px;

  background-image: url(${images.dossier_arrow.src});
  background-size: cover;

  cursor: pointer;
`;

export const ArrowLeft = styled(ArrowRight)`
  transform: rotate(180deg);
  margin: 0 12px 0 0;
`;

export const DotsWrapper = styled.div`
  width: 100%;

  margin: 12px 0;

  display: flex;
  justify-content: center;
`;

export const Dot = styled.div`
  width: 10px;
  height: 10px;

  margin: 0 4px;

  border: 2px solid #ff0000;
  border-radius: 50%;

  background-color: ${({ active }) => (active ? "#FF0000" : "#fff")};
`;
